import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardLayout from '../../../../layout/dashboard/dashboardLayout';
import './styles/SettingsLayout.css';
import EmptyScreen from '../../../../components/common/emptyScreen';
import RootState from '../../../../redux/types';
import { useSelector } from 'react-redux';
import {
	colorToRgba,
	getActionNamesByPolicyName,
} from '../../../../utils/helper/Helper';
import { ALL_ROUTES } from '../../../../routes/dashboard/overview/AllPathNames';
import RavenTabTest from '../../../../components/common/tab-link-comp/TabLinkComp';
import { RavenTab } from '@ravenpay/raven-bank-ui';

interface MyComponentProps {
	children?: React.ReactNode;
	btnContent?: React.ReactNode;
}

const SettingsLayout = ({ children, btnContent }: MyComponentProps) => {
	const { profile } = useSelector((state: RootState) => state.settings);
	const location = useLocation();
	const navigate = useNavigate();

	const settingRoutesList = [
		{
			name: 'General',
			link: ALL_ROUTES?.BANBOX_SETTINGS,
			active: location?.pathname === ALL_ROUTES?.BANBOX_SETTINGS,
		},
		{
			name: 'Team Management',
			link: ALL_ROUTES?.TEAM_SETTINGS_INDEX,
			active: location?.pathname === ALL_ROUTES?.TEAM_SETTINGS_INDEX,
		},
		{
			name: 'Roles and Permissions',
			link: ALL_ROUTES?.ROLES_AND_PERMISSION,
			active: location?.pathname === ALL_ROUTES?.ROLES_AND_PERMISSION,
			hide: getActionNamesByPolicyName(
				profile?.rolePolicies?.policies,
				'roles'
			)?.includes('view_roles')
				? false
				: true,
		},
	];

	const listToUse = [
		{
			label: 'General',
			value: ALL_ROUTES?.BANBOX_SETTINGS,
			active: location?.pathname === ALL_ROUTES?.BANBOX_SETTINGS,
			onClick: () => {
				navigate(ALL_ROUTES?.BANBOX_SETTINGS);
			},
		},
		{
			label: 'Team Management',
			value: ALL_ROUTES?.TEAM_SETTINGS_INDEX,
			active: location?.pathname === ALL_ROUTES?.TEAM_SETTINGS_INDEX,
			onClick: () => {
				navigate(ALL_ROUTES?.TEAM_SETTINGS_INDEX);
			},
		},
		{
			label: 'Roles and Permissions',
			value: ALL_ROUTES?.ROLES_AND_PERMISSION,
			active: location?.pathname === ALL_ROUTES?.ROLES_AND_PERMISSION,
			hide: getActionNamesByPolicyName(
				profile?.rolePolicies?.policies,
				'roles'
			)?.includes('view_roles')
				? false
				: true,
			onClick: () => {
				navigate(ALL_ROUTES?.ROLES_AND_PERMISSION);
			},
		},
	];

	if (
		!getActionNamesByPolicyName(
			profile?.rolePolicies?.policies,
			'settings'
		)?.includes('view_settings')
	) {
		return (
			<DashboardLayout>
				<>
					<EmptyScreen
						loading={Object?.keys(profile)?.length < 1 ? true : false}
						title="Permission Denied"
						subTitle="You have no permission to access this page, Please contact admin or support."
					></EmptyScreen>
				</>
			</DashboardLayout>
		);
	}

	return (
		<>
			<DashboardLayout>
				<div className="settings-layout-index-wrap-box">
					<div className="settings__title">
						<div className="title__main">
							<h5>BankBox Settings</h5>
							<p>Manage your account and profile settings</p>
						</div>
					</div>
					{/* children wrapper b ox start  */}
					<div className="children-route-wrapper-box white-faded-white-bg">
						{/* reusable tab start */}
						<RavenTab
							activeBgColor={colorToRgba('var(--primary-base-color)', 0.1)}
							activeColor="var(--primary-base-color)"
							list={listToUse}
							style={{ marginTop: '0rem' }}
						>
							<div className="right-box-btn">{btnContent || ''}</div>
						</RavenTab>
						{/* reusable tab end */}

						{/* chidren box start */}
						<div className="children-wrap-box">{children}</div>
						{/* chidren box end */}
					</div>
					{/* children wrapper b ox end */}
				</div>
			</DashboardLayout>
		</>
	);
};

export default SettingsLayout;
